import type { ReactNode } from "react"
import type { Round } from "@/types"

/** Lobby is set up before the room is watching, so it has no mark. */
export type RailRound = Exclude<Round, "lobby">

/**
 * The wrapper's viewBox, stroke width and linecaps are its values too, so every icon detail
 * lives here rather than at the call site.
 */
const SHAPES: Record<RailRound, ReactNode> = {
  pains: (
    <>
      <path d="M4 3.5h9l3 3v10H4z" />
      <path d="M7 8h6M7 11.5h4" />
    </>
  ),
  job: (
    <>
      <circle cx="10" cy="10" r="7" />
      <circle cx="10" cy="10" r="3.2" />
      <circle cx="10" cy="10" r="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  cards: (
    <>
      <rect x="6.4" y="3.4" width="9.4" height="13.2" rx="1.6" />
      <path d="M4.6 5.6 3.2 14a1.6 1.6 0 0 0 1.2 1.9l2.1.5" />
    </>
  ),
  priorities: (
    <>
      <rect x="3" y="3" width="6" height="6" rx="1.2" />
      <rect x="11" y="3" width="6" height="6" rx="1.2" />
      <rect x="3" y="11" width="6" height="6" rx="1.2" />
      <rect x="11" y="11" width="6" height="6" rx="1.2" />
    </>
  ),
  deep: (
    <>
      <circle cx="9" cy="9" r="5.4" />
      <path d="M13 13l4 4" />
    </>
  ),
  wrap: <path d="M4.5 16.5V8M9.5 16.5V4M14.5 16.5v-6" />,
}

interface RoundRailIconProps {
  round: RailRound
  className?: string
}

export default function RoundRailIcon({ round, className }: RoundRailIconProps) {
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {SHAPES[round]}
    </svg>
  )
}
